import { render, staticRenderFns } from "./ComplainDetailInput.vue?vue&type=template&id=700cace6&"
import script from "./ComplainDetailInput.vue?vue&type=script&lang=js&"
export * from "./ComplainDetailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports